import { MuiThemeProvider } from "@material-ui/core"
import { useThemeColorState } from "../store/ThemeColorState";

function ThemeProviderComponent(props) {
  const { theme } = useThemeColorState();
  
  return (
    <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
  )
}

export default ThemeProviderComponent;
